export default __webpack_public_path__ + "static/media/hoop-pin.745d710e.svg";